import { render, staticRenderFns } from "./SetPaySectionsToWorkers.vue?vue&type=template&id=0f1ee210&"
import script from "./SetPaySectionsToWorkers.vue?vue&type=script&lang=js&"
export * from "./SetPaySectionsToWorkers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports